<script setup>
const route = useRoute()

const { data: page } = await useAsyncData(route.path, () => {
  return queryCollection('content').path(route.path).first()
});

</script>

<template>
  <article class="prose dark:prose-invert lg:prose-xl max-w-none">
    <ContentRenderer :value="page" />
  </article>
</template>